var render = function render(){var _vm=this,_c=_vm._self._c;return _c('routine-editor',{ref:"editor",attrs:{"coach-id":_vm.coachId},on:{"close":_vm.onClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }